import React,{useState,useEffect} from 'react';
import {Helmet} from 'react-helmet';
import "../../styles/main.css"
import "../../styles/responsive.css"
import "../../styles/colorysentimiento.css"
import "../../styles/colorysentimientoresponsive.css"
import logoupc from '../../images/logo_upc.png'
import icon_search from '../../images/icon-search.png'
import { Link } from 'gatsby'
import arrow_down from '../../styles/icons/drop-down-arrow.svg'
import { graphql, useStaticQuery } from "gatsby"
import { navigate } from "@reach/router"  
import BlogCard from '../cards/blogcard'
import { useLocation } from "@reach/router"
import "../../styles/template3.css"
import "../../styles/template3part2.css"
import "../../styles/shared.css"

const Layout = ({children,
    descritpion,
    imgurl,
    subtitile,
    title,
    metaTitle,
    metaKeywords,
    metaDescripcin
    }) => {

    const { pathname } = useLocation()
    const [Search, setSearch] = useState(true)

    const [SearchData, setSearchData] = useState()
    const [InputSearch, setInputSearch] = useState(false)

    let location = useLocation();

    const Datos = useStaticQuery(
        graphql`
            query {
                allContentfulGeneral(filter: {node_locale: {eq: "en-US"}}) {
                    nodes {
                    mostrarAlianzas
                    }
                }
                allContentfulArteYCultura(filter: {node_locale: {eq: "en-US"}}) {
                    nodes {
                      id
                      lista
                      titulo
                      descripcion
                      fecha
                      enExhibicion
                      imagenDeLaEntrada {
                        file {
                          fileName
                          url
                        }
                        fluid {
                            ...GatsbyContentfulFluid
                        }
                        description
                      }
                    }
                }
            }
        `)
    const [menuDropdown, setMenuDropdown] = useState(false)
    const CategoriesClick = () => {
        setMenuDropdown(prevValue => !prevValue);
    }
        
    const [ValueMenuRight, setValueMenuRight] = useState(false)
    
    const menu_right = () => {
        setValueMenuRight(!ValueMenuRight)
        setInputSearch(false)
    }
    
    const SearchFunction = (inputdatatext) => {
        let FilteredDataTitleSubtitle = Datos.allContentfulArteYCultura.nodes.filter(data => data.titulo.toLocaleLowerCase().includes(inputdatatext) || data.descripcion.toLocaleLowerCase().includes(inputdatatext));
        let filteredListData = [];
        for (let i = 0; i < Datos.allContentfulArteYCultura.nodes.length; i++) {
            let datatemp 
            for (let y = 0; y < Datos.allContentfulArteYCultura.nodes[i].lista.length; y++) {
                if(Datos.allContentfulArteYCultura.nodes[i].lista[y].toLocaleLowerCase().includes(inputdatatext)){
                    if(datatemp !== Datos.allContentfulArteYCultura.nodes[i].id){
                        datatemp = Datos.allContentfulArteYCultura.nodes[i].id;
                        filteredListData.push(Datos.allContentfulArteYCultura.nodes[i])
                    }
                }
            }
        }
        let filteredEntireData = FilteredDataTitleSubtitle.concat(filteredListData);
        Array.prototype.unique=function(a){
            return function(){return this.filter(a)}}(function(a,b,c){return c.indexOf(a,b+1)<0
        });
        setSearchData(filteredEntireData.unique())
    }

    const Redirect = () => {
        if(pathname === '/artesaudiovisuales' || pathname === '/artesescenicas'  || pathname === '/artesplasticas' || pathname === '/creacionliteraria'  || pathname === '/disenoyartesvisuales'  || pathname === '/musicaycreacionsonora' || pathname === '/patrimonio' ){
            navigate(`/arteycultura`)
        }
    }

    const clickSearch = () => {
        if(pathname === '/artesaudiovisuales' || pathname === '/artesescenicas'  || pathname === '/artesplasticas' || pathname === '/creacionliteraria'  || pathname === '/disenoyartesvisuales'  || pathname === '/musicaycreacionsonora' || pathname === '/patrimonio' ){
            navigate(`/arteycultura`)
        }

        let inputdatatext = document.getElementById("input-search").value.toString().toLocaleLowerCase();
        SearchFunction(inputdatatext);
        setSearch(false);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if(pathname === '/artesaudiovisuales' || pathname === '/artesescenicas'  || pathname === '/artesplasticas' || pathname === '/creacionliteraria'  || pathname === '/disenoyartesvisuales'  || pathname === '/musicaycreacionsonora' || pathname === '/patrimonio' ){
                navigate(`/arteycultura`)
            }
            let inputdatatext = document.getElementById("input-search").value.toString().toLocaleLowerCase();
            SearchFunction(inputdatatext);
            setSearch(false)
            setInputSearch(false)
        }
    }

    const handleKeyDownMobile = (e) => {
        if (e.key === 'Enter') {
            if(pathname === '/artesaudiovisuales' || pathname === '/artesescenicas'  || pathname === '/artesplasticas' || pathname === '/creacionliteraria'  || pathname === '/disenoyartesvisuales'  || pathname === '/musicaycreacionsonora' || pathname === '/patrimonio' ){
                navigate(`/arteycultura`)
            }
            let inputdatatext = document.getElementById("input-search-mobile").value.toString().toLocaleLowerCase();

            SearchFunction(inputdatatext);
            setSearch(false)
            setInputSearch(false)
        }
    }

    const clickSearchMobile = () => {
        if(pathname === '/artesaudiovisuales' || pathname === '/artesescenicas'  || pathname === '/artesplasticas' || pathname === '/creacionliteraria'  || pathname === '/disenoyartesvisuales'  || pathname === '/musicaycreacionsonora' || pathname === '/patrimonio' ){
            navigate(`/arteycultura`)
        }
        let inputdatatext = document.getElementById("input-search-mobile").value.toString().toLocaleLowerCase();
        SearchFunction(inputdatatext);
        setSearch(false)
        setInputSearch(false)
    }

    const onClickFalse = () => {
        setSearch(true)
    }

    const onSeachMobile = () => {
        setInputSearch(!InputSearch)
    }
    useEffect(() => {
        return () => {
            var scripts = document.getElementsByTagName('script')
            if(scripts.length){
                for (let i = 0; i < scripts.length; i++) {
                    if(scripts[i].src.includes('http://in.getclicky.com/in.php?site_id=101276518&type=pageview&href=%2Farte')){
                    }
                }
            }
        }
    }, [])

    return (
        <>  
            <Helmet>
                <title>{title ? title : "UPC"}</title>
                <meta property="type" content="website" />
                <meta property="url" content={`https://cultural.upc.edu.pe${location.pathname}`}/>
                <meta property="og:title" content={title} />    
                <meta property="quote" content={`#${title}`} />
                <meta property="image" content={`https:${imgurl}`} />
                <meta property="og:locale" content="es_PE" />
                <meta property="og:description" content={descritpion}/>    
                <meta property="og:type" content="website" />
                <meta property="og:quote" content={`#${title}`} />
                <meta property="og:image" content={`https:${imgurl}`} />
                <meta content="image/*" property="og:image:type" />
                <meta property="og:url" content={`https://cultural.upc.edu.pe${location.pathname}`} />
                <meta property="og:site_name" content="Cultural Universidad Peruana de Ciencias Aplicadas" />
                <meta property="twitter:image" content={`https:${imgurl}`}/>
                <meta name="description" content={metaDescripcin}/>
                <meta name="keywords" content={metaKeywords}/>
            </Helmet>
                {InputSearch ?
                        <div className="background-color-phone" onClick={onSeachMobile} tabIndex="0" role="button" onKeyDown={(ev)=>{if(ev.keyCode === 13){onSeachMobile()}}}>
                        </div> : null
                }
            <nav className="header">
                <div className="header_content d-flex flex-row align-items-center justify-content-start">
                    <div className="logo"><Link to={"/"}>UPC CULTURAL</Link></div>
                    <div className="vertical_line"></div>
                    <Link to={"/"} className="img-redirect">
                    <div><img src={logoupc} alt="logo" className="logo_img"></img></div></Link>
                    <nav className="main_nav">
                        <ul className="d-flex flex-row align-items-start justify-content-start">
                            <li><Link onClick={onClickFalse} onKeyDown={(ev)=>{if(ev.keyCode === 13){onClickFalse()}}} tabIndex="0" role="button" to={"/arteycultura"}>+ARTE Y CULTURA</Link></li>
                            <li><Link onClick={onClickFalse} onKeyDown={(ev)=>{if(ev.keyCode === 13){onClickFalse()}}} tabIndex="0" role="button" to={"/nosotros"}>QUIÉNES SOMOS</Link></li>
                            {
                                Datos.allContentfulGeneral.nodes[0].mostrarAlianzas ?
                                
                                <li style={{'display':'block'}}><Link to={"/alianzas"}>ALIANZAS</Link></li>
                                : null
                            }
                        </ul>
                        <div className="search">
                            <input tabIndex="0" onKeyDown={handleKeyDown} onClick={Redirect} type="text" className="input-text-search" id="input-search"></input>
                            
                            <img onClick={clickSearch} tabIndex={-42} key={1} role='presentation' src={icon_search} alt="icono" className="icon_search" style={{'cursor':'pointer'}}></img>
                        </div>
                    </nav>
                    <div className="hamburger ml-auto" aria-label="search" onKeyDown={(ev)=>{if(ev.keyCode === 13){onSeachMobile()}}} tabIndex="0" role="button" onClick={onSeachMobile} ><i className="fa fa-search"  aria-hidden="true"></i></div>
                    <div className="hamburger ml-4" aria-label="search" onKeyDown={(ev)=>{if(ev.keyCode === 13){menu_right()}}} tabIndex="0" role="button" onClick={menu_right}><i className="fa fa-bars" aria-hidden="true"></i></div>
                </div>
                <div className={"search_mobile " + (InputSearch ? 'active_search' : '')}>
                    <input tabIndex="0" onClick={Redirect} aria-label="search" onKeyDown={handleKeyDownMobile} role="button" type="text" className="input-text-search" id="input-search-mobile"></input>     
                    <img onClick={clickSearchMobile} tabIndex={-42} key={1} role='presentation' src={icon_search} alt="icono" className="icon_search" style={{'cursor':'pointer'}}></img>
                </div>
            </nav>

            <div className={"menu text-right"+ (ValueMenuRight ? ' active' : '')}>
            <nav className="menu-desplegable landscape d-block d-sm-none d-sm-block d-md-block d-lg-none menu-active" id="menu-desplegable">
                    <div className="container-fluid">
                    <div className="row">
                        <div className="col-9">
                        <figure className="movil-img-white text-left">
                            <img src={logoupc} alt="logo" className="logo_img img_menu_right"/>
                        </figure>
                        </div>
                        <div className="col-3 text-right">
                        <figure className="border-ocultar" onClick={menu_right} tabIndex={-42} key={1} role='presentation'>
                            <h1>X</h1>
                        </figure>
                        </div>
                    </div>
                    <div className="height--25"></div>
                    <div className="row">
                        <div className="col-12">
                            <ul className="list-movil-menu " id="list-movil">
                                <li>
                                    <div className="border-list btn-menu-item" data-desplegar="btn-desplegar">
                                        <Link to={"/arteycultura"} className="item-span-menu">+ARTE Y CULTURA</Link>
                                    </div>
                                </li>
                                <li>
                                    <div className="border-list btn-menu-item" data-desplegar="btn-desplegar-2">
                                        <Link to={"/nosotros"} className="item-span-menu">QUIÉNES SOMOS</Link>
                                    </div>
                                </li>
                                {
                                    Datos.allContentfulGeneral.nodes[0].mostrarAlianzas ?
                                    <li>
                                        <div className="border-list btn-menu-item" data-desplegar="internacional">
                                            <Link to={"/alianzas"} className="item-span-menu">ALIANZAS</Link>
                                        </div>
                                    </li> : null
                                }
                            </ul>
                        </div>

                    </div>
                    <div className="height--25"></div>
                    </div>
                </nav>
            </div>  
            { Search ?
                <div>
                {children}
                </div>
                : 


            <div>
            <div className="service">
                <div className="service-subcontainer">
                        <div className="menu-left">
                            <div style={{'height':'100px'}}>
                                <h1>+ARTE Y CU<span>LTURA</span></h1>
                            </div>
                            <div className="subtittle">
                                <p>Visita y descubre
                                experiencias, eventos
                                y noticias de contenido
                                artístico y cultural.
                                </p>
                                <p>Toma en cuenta las siguientes categorías:</p>
                                <ul>
                                    <li><Link to={`/artesaudiovisuales`}>Artes audiovisuales</Link></li>
                                    <li><Link to={`/artesescenicas`}>Artes escénicas</Link></li>
                                    <li><Link to={`/artesplasticas`}>Artes plásticas</Link></li>
                                    <li><Link to={`/creacionliteraria`}>Creación literaria</Link></li>
                                    <li><Link to={`/disenoyartesvisuales`}>Diseño y artes visuales</Link></li>
                                    <li><Link to={`/musicaycreacionsonora`}>Música y creación sonora</Link></li>
                                    <li><Link to={`/patrimonio`}>Patrimonio</Link></li>
                                    <li><Link to={"/agendacultural"}>Agenda Cultural</Link></li>
                                    <li><Link to={"/enexhibicion"}>En exhibición</Link></li>
                                </ul>
                            </div>
                        </div>
                </div>
                <div className="container service-container">
                    <div className="title_responsive">
                        <h1>+ARTE Y CULTURA</h1>
                        <p>Visita y descubre experiencias, eventos y noticias de contenido artístico-cultural.</p>
                    </div>
                    <div className="section-header">
                        <nav className="navigation">
                            <ul className="mainmenu">
                                <li onClick={CategoriesClick} tabIndex={-42} key={1} role='presentation'><h1>CATEGORÍAS
                                    <img src={arrow_down} alt="imagen de flecha"/></h1>
                                    <ul className={"submenu"+ (menuDropdown ? ' listactive' : '')}>
                                        <li><Link to={"/artesaudiovisuales"}>Artes audiovisuales</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/artesescenicas"}>Artes escénicas</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/artesplasticas"}>Artes plásticas</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/creacionliteraria"}>Creación literaria</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/disenoyartesvisuales"}>Diseño y artes visuales</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/musicaycreacionsonora"}>Música y creación sonora</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/patrimonio"}>Patrimonio</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/agendacultural"}>Agenda Cultural</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/enexhibicion"}>En exhibición</Link><div className="hr_submenu"></div></li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                        <div className="row container-blog-img-responsive">
                            { 
                                SearchData.map(Data => (
                                        <BlogCard data={Data} key={Data.id}>
                                        </BlogCard>
                                )) 
                            } 
                        </div>
                </div>
            </div>
        </div>




            }
        </>
    )
}

export default Layout
